import { useTranslation } from 'react-i18next';

/** 詳細ヒーロー／モーダル操作帯で共有する短ラベル・title 文言 */
export function useSampleDetailActionLabels() {
  const { t } = useTranslation();
  return {
    usageLabel: t('sample.add_usage_record'),
    usageShort: t('sample.add_usage_record_short', { defaultValue: '使用' }),
    editLabel: t('common.edit'),
    deleteLabel: t('common.delete'),
    editTitle: t('sample.edit_sample_description'),
    deleteTitle: t('sample.delete_sample_description'),
    shareShort: t('sample.external_share_links_short', { defaultValue: '共有' }),
    shareTitle: t('sample.external_share_links_tooltip'),
    pageLabel: t('sample.open_detail_page'),
    pageShort: t('sample.open_detail_page_short', { defaultValue: '詳細' }),
    backShort: t('common.back', { defaultValue: '戻る' }),
  };
}
